import { handleActions } from 'redux-actions';
import { RoomsValue } from 'ha/types/SearchFilters';
import { Actions } from '../constants';

interface RoomsFilterState {
  bedroomCount?: RoomsValue[];
}

export const initialState = {
  bedroomCount: [],
};

export default handleActions(
  {
    [Actions.UPDATE_SEARCH_PARAMS]: (
      _,
      {
        payload: { bedroomCount = [] },
      }: {
        payload: RoomsFilterState;
      },
    ) => ({
      bedroomCount: Array.isArray(bedroomCount) ? bedroomCount : [bedroomCount],
    }),
  },
  initialState,
);

export const getRoomsFilter = (state: RoomsFilterState) => state;
